import { render, staticRenderFns } from "./truck_type_add.vue?vue&type=template&id=55bd38c2&scoped=true&"
import script from "./truck_type_add.vue?vue&type=script&lang=js&"
export * from "./truck_type_add.vue?vue&type=script&lang=js&"
import style0 from "./truck_type_add.vue?vue&type=style&index=0&id=55bd38c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bd38c2",
  null
  
)

export default component.exports